import { render } from "./GetInTouchComponent.vue?vue&type=template&id=32e535d2"
import script from "./GetInTouchComponent.vue?vue&type=script&lang=js"
export * from "./GetInTouchComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__